<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M34.0126 24.3821C34.1423 20.7535 36.8038 17.8129 40.2349 17.1898L40.2406 17.0714C36.0538 16.922 32.5352 20.1924 32.3858 24.3792C32.2364 28.566 35.5068 32.0846 39.6936 32.234L39.7021 32C36.3245 31.1317 33.8829 28.0078 34.0126 24.3792V24.3821Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.5967 32.2425C45.7869 32.2425 49.1837 28.8457 49.1837 24.6555C49.1837 20.4654 45.7869 17.0686 41.5967 17.0686C37.4066 17.0686 34.0098 20.4654 34.0098 24.6555C34.0098 28.8457 37.4066 32.2425 41.5967 32.2425Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.5957 17.0855V19.7188"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.5957 29.4597V32.0959"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M34.0918 24.5907H36.7251"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M46.4648 24.5907H49.101"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M44.6322 19.7047L41.5957 24.6555L43.8089 27.9176"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M91.2695 18.6277C92.682 19.4622 94.1819 20.5702 95.5804 22.0476C97.5427 24.1255 98.7522 26.3556 99.5219 28.3123"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M103.073 52.8268C103.73 55.5475 105.737 72.6104 91.2599 80.0592C77.9553 86.9018 55.6652 82.7517 56.0458 79.8816C56.1953 78.7566 63.4326 77.2004 72.2263 76.5096"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M88.9907 76.5293C95.7347 77.2173 101.334 78.9315 103.119 82.3034C105.752 87.2684 102.538 91.5849 98.9572 94.5988C86.5097 105.076 60.4219 103.26 37.458 102.019C19.2702 101.035 13.8513 92.8395 17.6096 82.1286C18.4385 79.766 19.6452 77.5584 21.1197 75.5369C23.6261 72.1029 28.8223 66.7743 38.2982 57.6508"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M38.4885 95.1063L38.0938 99.3015L42.0127 99.3156L42.5202 94.8159"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.6649 24.2946C75.2119 21.9179 74.9158 19.6596 74.0926 17.452C73.9432 17.0488 73.774 16.6485 73.5907 16.2481C72.7703 14.455 70.5937 14.4409 68.8739 14.8018C67.2105 15.1486 65.4089 15.8619 64.6195 17.3674C63.5876 19.3382 63.9231 21.8502 64.4024 23.9253C64.6758 25.1066 65.048 26.2654 65.4878 27.3932C65.8797 28.394 66.5564 29.5979 67.515 30.1956C67.9604 30.4719 68.3974 30.5791 68.8457 30.5734L68.9529 31.8957L69.0572 33.2208C69.0572 33.2208 71.5129 33.4943 72.8774 33.2208C74.242 32.9473 74.4394 32.812 74.4394 32.812L73.5456 27.4834C73.5907 27.4354 73.633 27.3847 73.6781 27.3368C74.5183 26.4205 74.3886 25.5042 74.6677 24.2918L74.6649 24.2946Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M75.7483 17.7819C75.7427 17.7029 75.7371 17.624 75.7314 17.5394C75.7145 17.3223 75.6581 17.1278 75.5735 16.9558C75.1534 16.0508 73.9524 15.735 72.9459 15.1909C72.4496 14.923 71.945 14.7482 71.4347 14.6439C70.3859 14.4324 68.9029 14.627 67.7864 14.8497C66.3429 15.1401 64.764 15.9239 63.749 17.0545C63.36 17.4858 63.1062 18.0131 63.0329 18.591C62.8919 19.6596 63.3177 20.9706 63.9436 21.8333C63.9436 21.8333 63.7237 20.2376 66.5346 20.122C67.0139 20.105 67.5242 20.1953 67.9978 20.0966C68.5138 19.9866 68.9085 19.6539 69.3991 19.4848C69.7318 19.3692 70.0363 19.3325 70.3041 19.3635C70.5578 19.3946 70.789 19.4848 70.9892 19.6314C71.5418 20.012 71.9055 20.7422 72.1649 21.5119C72.2523 21.7657 72.5512 21.8897 72.7852 21.7544C73.0389 21.605 73.3406 21.588 73.6451 21.822C74.4401 22.431 74.5388 23.7843 74.3443 24.6809C74.24 25.1602 73.8565 25.9073 73.3434 26.1442C73.5492 26.9533 73.0502 28.2418 73.9016 28.2418C74.4345 28.2418 74.3556 27.0548 74.4345 26.7447C74.7672 25.3801 75.1619 24.0183 75.4185 22.6368C75.6553 21.3794 75.9034 19.8626 75.7511 17.7875L75.7483 17.7819Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.5957 85.0467L38.98 81.6127"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M33.3399 84.6887L32.4434 87.7167H36.5202"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M50.2222 57.1207C44.2197 55.8717 42.514 57.304 39.3197 66.3852C36.1084 75.5031 32.1641 84.7958 32.1641 84.7958C32.1641 84.7958 32.6123 84.731 35.1498 84.2939C36.7681 84.0148 38.2286 83.2705 38.9447 81.7057L46.2384 68.4039C47.2196 66.6136 48.914 65.3195 50.9017 64.8458L64.5193 61.6007C64.5193 61.6007 67.7278 60.7662 50.2194 57.1207H50.2222Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M39.7655 80.2735C39.5737 82.061 39.3989 83.8654 39.2439 85.5711C38.773 90.8011 38.4883 95.1063 38.4883 95.1063C38.4883 95.1063 38.5221 95.1119 38.587 95.126C42.2663 95.7829 45.8835 93.6853 47.1635 90.1723L52.01 76.2079C52.9066 73.5605 53.1632 72.9177 53.4761 72.1621C53.4761 72.1565 53.4818 72.1565 53.4874 72.1565C53.6932 71.9732 55.8867 72.0522 58.8386 72.1621C61.6439 72.258 65.1286 72.3679 68.2243 72.2834H68.23C69.0363 72.2608 69.8201 72.227 70.5531 72.1734C71.8303 72.0832 72.9693 71.9394 73.8715 71.7279C74.5707 71.5616 75.1515 71.2402 75.6393 70.8004"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.9023 59.0661C70.08 58.8152 70.5564 58.1555 70.8412 57.741C71.8872 56.2242 72.3665 54.1097 72.6851 51.5468C72.7076 51.3241 72.7358 51.0957 72.7584 50.8702C72.7753 50.7264 72.7866 50.5826 72.8035 50.436C72.826 50.2076 72.843 49.9793 72.8655 49.7537C72.8937 49.4323 72.9163 49.1081 72.9445 48.7754C72.967 48.5301 72.9839 48.282 73.0008 48.0311C73.139 46.0237 73.2518 43.8809 73.4745 41.7015C74.1427 35.0732 76.3362 33.1729 76.3362 33.1729C76.3362 33.1729 76.3418 33.1729 76.3531 33.1786C76.3531 33.1786 76.3587 33.1785 76.3644 33.1842"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.5762 66.5629C78.8488 68.325 78.7896 68.4631 78.3864 70.7412C78.0425 72.695 76.6976 72.7373 75.7926 71.0288C71.6847 63.298 69.0825 62.83 68.3945 62.3958"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.8005 40.6442L52.2225 38.9667C52.1999 38.9019 52.1915 38.8398 52.1858 38.7806C52.1633 38.5833 52.2338 38.4 52.3494 38.2562C52.4819 38.0927 52.682 37.9855 52.9217 37.9855H56.6179C56.9365 37.9855 57.2156 38.1857 57.3227 38.4846L59.7474 45.5246C59.8376 45.784 59.77 46.0546 59.6093 46.2463C59.4937 46.3789 59.3273 46.4747 59.1384 46.4945C59.1074 46.5057 59.0736 46.5057 59.0426 46.5057H56.539"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.9267 45.6204C55.9267 45.6204 55.9323 45.6007 55.9323 45.5894C55.9887 45.2793 55.9972 44.9635 55.9661 44.6506C56.0874 44.6139 56.2001 44.5519 56.2932 44.4476C56.3101 44.4307 56.3214 44.4137 56.3214 44.3912C56.3496 44.3292 56.3552 44.2587 56.3439 44.191C56.3214 44.0811 56.2763 43.9796 56.2171 43.8978C56.2735 43.8696 56.3214 43.8358 56.3609 43.7935C56.4116 43.7484 56.4567 43.6948 56.4821 43.6271C56.5216 43.5369 56.5385 43.4608 56.5385 43.3818C56.5441 43.2437 56.4934 43.1196 56.4172 43.0097C56.4229 42.9984 56.4342 42.9871 56.4398 42.9702C56.468 42.8151 56.4342 42.6714 56.3721 42.536C56.327 42.4317 56.2622 42.3359 56.1889 42.2485C56.0846 42.1272 55.9605 42.0201 55.8562 41.9383C55.8224 41.9101 55.7829 41.8932 55.7462 41.8707C55.7913 41.6874 55.7688 41.521 55.6955 41.3829C55.3008 40.5766 53.3441 40.4553 52.9494 40.695C52.5321 40.9572 52.0387 41.5182 52.0613 42.2287C52.0782 43.1112 52.8902 45.0227 52.8902 45.0227C52.9381 45.144 52.986 45.268 53.034 45.3977C52.4475 46.1364 51.8752 47.1062 52.4645 48.0085C52.9748 48.7922 54.5395 49.0629 55.3487 48.6851C56.1522 48.3101 56.8035 47.0724 56.3975 46.2153C56.2904 45.9898 56.1268 45.7924 55.9267 45.6233V45.6204Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M66.5117 62.0265C66.5737 62.0236 66.6358 62.0152 66.6978 62.0067L66.929 62.0575L67.2448 62.1251L69.8019 62.6862C69.8189 62.6918 69.8301 62.6918 69.8301 62.6918L70.5914 62.799"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.8273 59.1761H69.7427L66.974 59.1817H66.585C66.4017 59.0605 66.2213 58.9364 66.0408 58.818C64.93 58.0737 63.8445 57.445 62.3277 57.4957C62.2798 57.4957 62.1642 57.5183 62.0317 57.5408C61.5496 57.6254 61.0731 57.741 60.6051 57.882C60.3147 57.9694 60.0327 58.0568 59.6211 58.1808"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.2455 43.1732C46.8802 49.108 45.0561 52.7027 45.8145 54.4818C47.0748 57.4421 51.9551 56.3679 55.6542 53.8389C55.547 54.1237 55.4427 54.4479 55.3243 54.8173C55.3017 54.8934 55.2735 54.9667 55.251 55.0485C54.955 56.007 54.6871 56.8952 54.5236 57.6789M65.1188 56.7485C65.3557 54.2618 65.5417 50.8194 65.3472 46.9625C65.178 43.6074 64.9891 39.0062 66.943 35.3438C67.3997 34.4895 67.9777 33.576 67.9777 33.576C64.149 34.5487 60.5571 36.2347 57.3853 38.5241"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M68.7207 30.5706C68.9434 30.5847 69.2395 30.5819 69.575 30.5227C70.0289 30.4437 70.3841 30.2943 70.6181 30.1759"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.2847 51.4058C76.1917 51.8738 76.1184 52.4293 76.1128 53.058C76.1043 54.2393 76.3383 55.2176 76.5695 55.9056C76.5695 55.9056 75.3459 56.0663 73.4935 56.602C70.8461 57.3716 65.4047 61.6571 75.0301 65.3026C84.6555 68.948 88.4137 62.2266 88.0726 50.2104C88.0303 48.7077 87.9147 47.3487 87.7427 46.1223C86.9279 40.2777 82.8511 35.4058 77.2659 33.4943L76.3298 33.1729"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M26.8382 96.6738C26.8382 96.6738 25.203 96.6456 26.0347 95.1711C26.8664 93.6966 29.2516 91.7117 30.3512 89.8086C31.118 88.4779 31.586 87.4122 32.4742 87.071C32.8491 86.9272 32.9563 87.0767 33.9177 87.0738C35.8856 87.0682 36.3057 86.5945 36.7399 86.9272C37.4447 87.4657 36.9795 89.1997 36.4664 91.1225C36.1253 92.3997 35.8546 92.8085 35.7052 93.0002C35.2174 93.6176 34.4956 93.9954 33.3312 94.5537C30.4837 95.9211 30.2017 96.8599 28.6398 96.9389C27.8616 96.9783 27.2216 96.8035 26.8438 96.671L26.8382 96.6738Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M38.615 97.311C38.4656 97.311 38.3218 97.1983 36.523 98.7433C34.4226 100.545 32.4236 101.839 32.2094 103.229C31.9951 104.616 32.3165 105.064 34.7947 104.723C37.273 104.382 38.7447 103.719 40.4984 102.693C42.2492 101.667 42.6552 101.112 42.5903 99.8316C42.5255 98.5487 42.8244 97.0545 41.8855 97.2687C40.9466 97.483 38.6178 97.311 38.6178 97.311H38.615Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.5352 52.9706C50.0215 41.5013 51.2677 26.8208 65.9115 19.9387C91.8414 7.74767 100.457 39.8717 100.457 39.8717"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M87.5464 72.9431H80.5713C80.4472 72.9431 80.3457 72.8416 80.3457 72.7175V71.9394C80.3457 71.8153 80.4472 71.7138 80.5713 71.7138H87.5464C87.6705 71.7138 87.772 71.8153 87.772 71.9394V72.7175C87.772 72.8416 87.6705 72.9431 87.5464 72.9431Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M81.6201 79.7547L80.8223 72.9487H87.3097L87.1095 74.9477"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M86.7543 77.5443L86.4921 79.7124C86.4752 79.8421 86.3681 79.938 86.2384 79.938H81.8768C81.7471 79.938 81.6371 79.8393 81.623 79.7124"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.7279 67.2761C84.6123 67.4707 84.4713 67.778 84.5164 68.1389C84.5785 68.6238 84.9252 68.807 85.0296 69.2948C85.0775 69.5204 85.0831 69.8615 84.8407 70.3239"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M83.1982 68.215C83.0798 68.3503 82.936 68.5618 82.9783 68.807C83.0346 69.1369 83.3786 69.2581 83.4773 69.5908C83.5224 69.7431 83.5252 69.9771 83.2771 70.2957"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M22.3889 100.83C22.3889 100.83 14.6892 113.449 14.9457 113.449H17.8525L26.8548 101.681"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M90.1104 100.83C90.1104 100.83 97.8102 113.449 97.5536 113.449C95.0725 113.449 94.6468 113.449 94.6468 113.449L85.6445 101.681"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M105.607 91.145C105.607 91.145 113.306 101.475 113.05 101.475C110.569 101.475 110.143 101.475 110.143 101.475L101.141 91.8414"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
